
const LogoSmall = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
            <path d="M7.46513 14.3297C7.46513 16.3567 5.79401 18 3.73257 18C1.67112 18 0 16.3567 0 14.3297C0 12.3026 1.67112 10.6593 3.73257 10.6593C5.79401 10.6593 7.46513 12.3026 7.46513 14.3297Z" fill="#00192E" />
            <path d="M6.94559 5.38157C5.94945 3.64673 6.57212 1.4463 8.33637 0.466763C10.1006 -0.512774 12.3384 0.0995195 13.3345 1.83436L19.5253 12.616C20.5215 14.3509 19.8988 16.5513 18.1345 17.5308C16.3703 18.5104 14.1326 17.8981 13.1364 16.1632L6.94559 5.38157Z" fill="#00192E" />
        </svg>
    )
}

export default LogoSmall